import {Component, Input} from '@angular/core';
import {ModalsService} from "../../services/modals.service";
import {SubscriberService} from "../../services/subscriber.service";
import {Router} from "@angular/router";

@Component({
  selector: 'app-activate-subscription-modal',
  templateUrl: './activate-subscription-modal.component.html',
  styleUrls: ['./activate-subscription-modal.component.css']
})
export class ActivateSubscriptionModalComponent {
  @Input() privetPlus: boolean;

  requestInProgress: boolean;
  subscriptionCompleted: boolean;
  subscriptionActive: boolean;
  wrongServiceError:boolean;

  constructor(private readonly modalsService: ModalsService,
              private readonly subscriberService: SubscriberService,
              private readonly router: Router) {
    this.requestInProgress = false;
    this.subscriptionCompleted = false;
    this.subscriptionActive = false;
    this.wrongServiceError = false;
  }

  close(): void {
    this.modalsService.hideModal();
    if (this.subscriptionCompleted) {
      this.router.navigate(['/genres'])
    }
  }

  subscribe(): void {
    this.requestInProgress = true;
    this.subscriberService.activateSubscriptions(this.privetPlus)
      .subscribe((status) => {
        if (status == 'MSISDN_IN_USE') {
          this.wrongServiceError = true;
        }
        this.subscriberService.loadSubscriptions();
        this.requestInProgress = false;
        this.subscriptionCompleted = true;
      });
  }
}
